import { useIntl } from 'react-intl'
import { useSelector } from 'react-redux';
import { selectPayoutAt } from '@/processes/PoolStats/poolStats.selectors'
import { calculateEstimatedPeriod, getPayoutLocalTimeFromUtc } from '../utils/getEstPeriod';

type useNextPayoutProps = {
  coin: string;
  unpaid: number;
  currentAmount: number;
  estDailyEarnings: number;
  threshold: number;
  timeOffset?: number;
}

export const useNextPayout = (props: useNextPayoutProps) => {
  const { 
    coin,
    unpaid = 0,
    currentAmount = 0,
    estDailyEarnings = 0,
    threshold = 0,
    timeOffset = 3,
  } = props
  const intl = useIntl();
  const payoutAt = useSelector((state) => selectPayoutAt(state, coin));
  const remainingAmountToPayout = threshold - (unpaid + currentAmount);
  const estimateDays = currentAmount ? remainingAmountToPayout / estDailyEarnings : 0;
  const { symbol, value, title } = calculateEstimatedPeriod(estimateDays);
  const payoutDate = `${symbol} ${value} ${intl.formatMessage({ id: title })}`;
  const payoutTime = getPayoutLocalTimeFromUtc(payoutAt, timeOffset);
  
  // default values
  let progress = 0;
  let progressValue = '~';

  // populate values if data exists
  if (currentAmount && payoutAt && estDailyEarnings) {
    progress = remainingAmountToPayout >= 0 && remainingAmountToPayout < threshold
    ? Math.floor(100 - (remainingAmountToPayout * 100 / threshold)) 
    : 100;

    progressValue = estimateDays > 0 ? payoutDate : payoutTime;
  }
  
  return {
    progress,
    progressValue,
  }
}

export default useNextPayout;